@if (inline()) {
  <div class="learn-progress-inline" role="status">
    <div class="learn-progress__compact-row">
      <span class="learn-progress__compact-label">
        {{
          'app.parentLearning.progress.lessons'
            | translate: { completed: completedCount(), total: totalCount() }
        }}
      </span>
      <span class="learn-progress__compact-value">{{ percent() }}%</span>
    </div>
    @if (totalCount() > 0) {
      <div
        class="learn-progress__segments"
        role="progressbar"
        [attr.aria-valuenow]="completedCount()"
        [attr.aria-valuemin]="0"
        [attr.aria-valuemax]="totalCount()"
      >
        @for (index of segmentIndexes(); track index) {
          <span
            class="learn-progress__segment"
            [class.learn-progress__segment--filled]="index < completedCount()"
          ></span>
        }
      </div>
    }
  </div>
} @else if (compact()) {
  <div class="learn-progress learn-progress--compact" role="status">
    <div class="learn-progress__compact-row">
      <span class="learn-progress__compact-label">
        {{
          'app.parentLearning.progress.lessons'
            | translate: { completed: completedCount(), total: totalCount() }
        }}
      </span>
      <span class="learn-progress__compact-value">{{ percent() }}%</span>
    </div>
    <div
      class="learn-progress__segments"
      role="progressbar"
      [attr.aria-valuenow]="completedCount()"
      [attr.aria-valuemin]="0"
      [attr.aria-valuemax]="totalCount()"
    >
      @for (index of segmentIndexes(); track index) {
        <span
          class="learn-progress__segment"
          [class.learn-progress__segment--filled]="index < completedCount()"
        ></span>
      }
    </div>
  </div>
} @else {
  <div class="learn-progress">
    <div class="learn-progress__ring" [attr.aria-label]="percent() + '%'">
      <svg viewBox="0 0 96 96" aria-hidden="true">
        <circle class="learn-progress__track" cx="48" cy="48" r="42" />
        <circle
          class="learn-progress__fill"
          cx="48"
          cy="48"
          r="42"
          [style.stroke-dashoffset.px]="ringOffset()"
        />
      </svg>
      <span class="learn-progress__value">{{ percent() }}%</span>
    </div>
    <div class="learn-progress__meta">
      <p class="learn-progress__label">
        {{ 'app.parentLearning.progress.label' | translate }}
      </p>
      <p class="learn-progress__stats">
        {{
          'app.parentLearning.progress.lessons'
            | translate: { completed: completedCount(), total: totalCount() }
        }}
      </p>
      @if (totalPoints() > 0) {
        <p class="learn-progress__points">
          {{
            'app.parentLearning.progress.points'
              | translate: { points: totalPoints() }
          }}
        </p>
      }
      @if (totalCount() > 0) {
        <div
          class="learn-progress__segments"
          role="progressbar"
          [attr.aria-valuenow]="completedCount()"
          [attr.aria-valuemin]="0"
          [attr.aria-valuemax]="totalCount()"
        >
          @for (index of segmentIndexes(); track index) {
            <span
              class="learn-progress__segment"
              [class.learn-progress__segment--filled]="index < completedCount()"
            ></span>
          }
        </div>
      }
    </div>
  </div>
}
